/**
 * GEN-5844 name (`TRF_{OrderId}_{STATUS}_{YYYYMMDDHHmm}.pdf`, UTC) for a TRF the browser rendered
 * itself. Server-rendered TRFs carry their name in `Content-Disposition` (see `ProviderAPIClient`).
 */
export function clientTrfPdfFilename(orderId?: string | null, now: Date = new Date()): string {
  const stamp = now.toISOString().replace(/\D/g, '').slice(0, 12)
  const id = (orderId ?? '').replace(/[^A-Za-z0-9-]/g, '')
  return `${['TRF', id, 'SUBMITTED', stamp].filter(Boolean).join('_')}.pdf`
}
